import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
/* src/app/page.mypage/view.scss: no such file or directory */`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    // 세션 관리
    public sessions: any[] = [];
    public currentToken: string = '';
    public loadingSessions: boolean = false;

    // 접속 로그
    public accessLogs: any[] = [];
    public accessLogTotal: number = 0;
    public accessLogPage: number = 1;
    public loadingLogs: boolean = false;

    // 탭 관리
    public activeTab: string = 'profile';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
        }
        await this.service.render();
    }

    public async setTab(tab: string) {
        this.activeTab = tab;
        if (tab === 'sessions') {
            await this.loadSessions();
        } else if (tab === 'logs') {
            await this.loadAccessLogs();
        }
        await this.service.render();
    }

    // 프로필 업데이트
    public async updateProfile() {
        if (!this.user.name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("update_profile", {
            name: this.user.name,
            mobile: this.user.mobile || ''
        });

        await this.service.sleep(500);
        this.saving = false;

        if (code === 200) {
            await this.service.modal.success("프로필이 업데이트되었습니다.");
        } else {
            await this.service.modal.error(data.message || "업데이트에 실패했습니다.");
        }
        await this.service.render();
    }

    // 비밀번호 변경
    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error("현재 비밀번호를 입력해주세요.");
            return;
        }
        if (!new_password) {
            await this.service.modal.error("새 비밀번호를 입력해주세요.");
            return;
        }
        if (new_password.length < 8) {
            await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error("새 비밀번호가 일치하지 않습니다.");
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call("change_password", {
            current_password: current_password,
            new_password: new_password
        });

        await this.service.sleep(500);
        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success("비밀번호가 변경되었습니다.");
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            await this.service.modal.error(data.message || "비밀번호 변경에 실패했습니다.");
        }
        await this.service.render();
    }

    // 활성 세션 목록 로드
    public async loadSessions() {
        this.loadingSessions = true;
        await this.service.render();

        const { code, data } = await wiz.call('sessions');
        if (code === 200) {
            this.sessions = data.sessions || [];
            this.currentToken = data.current_token || '';
        }

        this.loadingSessions = false;
        await this.service.render();
    }

    // 특정 세션 강제 로그아웃
    public async revokeSession(sessionId: string) {
        const res = await this.service.modal.show({
            title: '세션 종료',
            message: '해당 기기의 세션을 종료하시겠습니까?',
            action: '종료',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!res) return;

        const { code } = await wiz.call('revoke_session', { session_token: sessionId });
        if (code === 200) {
            await this.service.modal.success("세션이 종료되었습니다.");
        }
        await this.loadSessions();
    }

    // 다른 모든 세션 로그아웃
    public async revokeAllSessions() {
        const res = await this.service.modal.show({
            title: '전체 세션 종료',
            message: '현재 세션을 제외한 모든 세션을 종료하시겠습니까?',
            action: '전체 종료',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!res) return;

        const { code } = await wiz.call('revoke_all_sessions');
        if (code === 200) {
            await this.service.modal.success("다른 세션이 모두 종료되었습니다.");
        }
        await this.loadSessions();
    }

    // 접속 로그 로드
    public async loadAccessLogs(page: number = 1) {
        this.loadingLogs = true;
        this.accessLogPage = page;
        await this.service.render();

        const { code, data } = await wiz.call('access_logs', { page, dump: 10 });
        if (code === 200) {
            this.accessLogs = data.rows || [];
            this.accessLogTotal = data.total || 0;
        }

        this.loadingLogs = false;
        await this.service.render();
    }

    // 페이지네이션 계산
    public get logPages() {
        return Math.ceil(this.accessLogTotal / 10);
    }

    // 날짜 포맷
    public formatDate(date: any) {
        if (!date) return '-';
        try {
            return this.service.formatter.date(date);
        } catch {
            return String(date).substring(0, 19);
        }
    }
}

export default PageMypageComponent;